module.exports = __webpack_public_path__ + "static/media/Modification_Dosimex GX_3.0.81ffaf88.pdf";